import type {SlotGameStore, ReelsetComponent as ReelsetComponentType} from "@gamzix/slot_core";

class WinSymbolsScaleComponent extends Game.src.component.BaseComponent {
    protected TIME_SHOW = 350;
    protected SCALE_SYMBOLS = 1.1;
    protected lineCall;

    onGameReady() {
        super.onGameReady();

        game.on(ReelsetComponent.events.SHOW_LINE, async ({ positions }) => {
            this.playSymbolsYoyoAnimations(positions);
        });

        game.on(ReelsetComponent.events.SHOW_POSITION, async ({ positions }) => {
            this.playSymbolsYoyoAnimations(positions);
        });
    }

    playSymbolsYoyoAnimations(positions: number[][]) {
        positions.forEach(([reelId, position]) => {
            this.playSymbolYoyoAnimation(reelId, position)
        })
    }

    async playSymbolYoyoAnimation(reelId: number, position: number) {
        //@ts-ignore
        const symbolView = this.reelset.getSymbol(reelId, position);

        await this.playScaleYoyoAnimation(symbolView, {scaleFrom: 1, scaleTo: this.SCALE_SYMBOLS, time: this.TIME_SHOW});
    }

    // scale object from scaleFrom -> scaleTo -> scaleFrom during time
    async playScaleYoyoAnimation(obj, {
        scaleFrom, scaleTo, time, onStart = () => {
        }, onFinish = () => {
        }
    }) {
        return new Promise((resolve) => {
            const _tw = {scale: scaleFrom};

            // @ts-ignore
            createjs.Tween.get(_tw, {
                onChange: () => {
                    // hack for not scale win_back
                    obj.children[0].children[0].scale.x = 1/_tw.scale;
                    obj.children[0].children[0].scale.y = 1/_tw.scale;

                    obj.scale.x = _tw.scale;
                    obj.scale.y = _tw.scale;
                }
            })
                .call(onStart.bind(this, obj))
                .to({scale: scaleTo}, time)
                .to({scale: scaleFrom}, time)
                .to({scale: scaleTo}, time)
                .to({scale: scaleFrom}, time)
                .call(onFinish.bind(this, obj))
                .call(resolve)
        });
    }

    get reelset(): ReelsetComponentType {
        return <any>game.component.reelset;
    }

    get store(): SlotGameStore {
        return <any>game.store;
    }

    getFSMHandlers(): {} {
        return {
            SHOW_WIN: {
                showAllWins: {
                    on: () => {
                        const lines = [...this.store.gameData.lines, ...this.store.gameData.positions];

                        lines.forEach(({positions}) => {
                            this.playSymbolsYoyoAnimations(positions);
                        })
                    }
                }
            }
        }
    }
}

//@ts-ignore
Game.src.component.WinSymbolsScaleComponent = WinSymbolsScaleComponent;
